<template>
  <div
    v-if="
      !isBulletinRoute &&
        !isRoleViewer &&
        !isOnlyAdminOrSpecialist &&
        bulletinUnreadCount > 0
    "
    class="bulletin-notification"
  >
    <span>Határidős feladat a Faliújságon!</span>

    <router-link to="/neta/bulletin">
      <a-button class="view-button">
        Megtekintem
      </a-button>
    </router-link>
  </div>
</template>

<script>
import { USER_UPDATE_BULLETIN_UNREAD } from "@/action_types.js";

export default {
  mounted() {
    if (this.isRoleViewer) {
      return;
    }

    this.$store.dispatch(USER_UPDATE_BULLETIN_UNREAD);
  },
  computed: {
    isOnlyAdminOrSpecialist() {
      return this.$store.getters.isOnlyAdminOrSpecialist();
    },
    isRoleViewer() {
      return this.$store.getters.hasRoleAvailable(["ROLE_MTU_VIEWER"]);
    },
    isBulletinRoute() {
      return this.$route.name.includes("bulletin");
    },
    bulletinUnreadCount() {
      return this.$store.getters.getBulletinUnreadCount;
    },
  },
};
</script>

<style lang="scss" scoped>
.bulletin-notification {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  font-weight: bold;
  text-align: center;
  font-size: 20px;
  background: #ff4d4f;
  color: white;
}

.view-button {
  margin-left: 12px;
}
</style>
